import { Facebook, Twitter, Linkedin, Send, MessageCircle, Mail, Link2 } from "lucide-react";
import { toast } from "sonner";

export default function SocialShare({ url, text, className = "" }) {
  const eu = encodeURIComponent(url);
  const et = encodeURIComponent(text);
  const etu = encodeURIComponent(`${text} ${url}`);

  const links = [
    { id: "whatsapp", label: "WhatsApp", Icon: MessageCircle, href: `https://wa.me/?text=${etu}` },
    { id: "x", label: "X", Icon: Twitter, href: `https://twitter.com/intent/tweet?text=${et}&url=${eu}` },
    { id: "facebook", label: "Facebook", Icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${eu}` },
    { id: "telegram", label: "Telegram", Icon: Send, href: `https://t.me/share/url?url=${eu}&text=${et}` },
    { id: "linkedin", label: "LinkedIn", Icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${eu}` },
    { id: "email", label: "Email", Icon: Mail, href: `mailto:?subject=${encodeURIComponent("A verse from AskYeshua")}&body=${etu}` },
  ];

  const open = (href) => window.open(href, "_blank", "noopener,noreferrer");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied to clipboard.");
    } catch {
      toast.message(url);
    }
  };

  return (
    <div data-testid="social-share" className={`flex flex-wrap items-center justify-center gap-2 ${className}`}>
      {links.map(({ id, label, Icon, href }) => (
        <button
          key={id}
          data-testid={`social-${id}`}
          onClick={() => open(href)}
          aria-label={`Share on ${label}`}
          title={label}
          className="flex h-10 w-10 items-center justify-center rounded-full border border-border bg-card text-muted-foreground transition-colors hover:border-primary hover:bg-primary hover:text-primary-foreground"
        >
          <Icon className="h-4 w-4" />
        </button>
      ))}
      <button
        data-testid="social-copy"
        onClick={copy}
        aria-label="Copy link"
        title="Copy link"
        className="flex h-10 w-10 items-center justify-center rounded-full border border-border bg-card text-muted-foreground transition-colors hover:border-primary hover:bg-primary hover:text-primary-foreground"
      >
        <Link2 className="h-4 w-4" />
      </button>
    </div>
  );
}
